export default __webpack_public_path__ + "static/media/4.41b7f7d3.jpg";